import { httpService } from '../http.service.js'

export const watchOrReadListService = {
  query,
  statusMap,
  stats,
  getById,
  save,
  remove,
  updateProgress,
  updateStatus,
  updateTotalRewatch,
}

/* ────────── helper: pick only whitelisted fields ────────── */
function filterFields(item, listType) {
  const base = [
    'anizone_id',
    'progress',
    'status',
    'start_date',
    'finish_date',
    'total_rewatchs',
    'metadata',
  ]
  const manga = ['title_english', 'title_hebrew', 'image_url', 'chapters']
  const allow = listType === 'watchlist' ? base : [...base, ...manga]

  return Object.keys(item).reduce((acc, k) => {
    if (allow.includes(k)) acc[k] = item[k]
    return acc
  }, {})
}

/* ────────── QUERY (page / limit / fields / sort) ────────── */
async function query(
  userId,
  listType,
  { page = 1, limit = 150, fields, ...filterBy } = {},
  sortBy = 'start_date'
) {
  try {
    const qs = new URLSearchParams({
      ...filterBy,
      page,
      limit,
      sortBy,
      ...(fields ? { fields } : {}),
    })
    return await httpService.get(
      `watchOrReadList/${userId}/${listType}?${qs.toString()}`
    )
  } catch (err) {
    console.error(`❌ [watchOrReadList.query] ${err?.message || err}`)
    throw err
  }
}

/* ────────── STATUS-MAP (ids → { status, progress }) ────────── */
async function statusMap(userId, listType, ids = []) {
  if (!ids.length) return {}
  try {
    const qs = new URLSearchParams({ ids: ids.join(',') }).toString()
    return await httpService.get(
      `watchOrReadList/${userId}/${listType}/status-map?${qs}`
    )
  } catch (err) {
    console.error(`❌ [watchOrReadList.statusMap] ${err?.message || err}`)
    throw err
  }
}

/* ────────── STATS (count per status) ────────── */
async function stats(userId, listType) {
  try {
    return await httpService.get(`watchOrReadList/${userId}/${listType}/stats`)
  } catch (err) {
    console.error(`❌ [watchOrReadList.stats] ${err?.message || err}`)
    throw err
  }
}

/* ────────── CRUD helpers ────────── */
async function getById(userId, listType, anizoneId) {
  try {
    return await httpService.get(
      `watchOrReadList/${userId}/${listType}/${anizoneId}`
    )
  } catch (err) {
    console.error(`❌ [watchOrReadList.getById] ${err?.message || err}`)
    throw err
  }
}

async function save(userId, listType, item) {
  const body = filterFields(item, listType)
  try {
    if (item.anizone_id) {
      return await httpService.put(
        `watchOrReadList/${userId}/${listType}/${item.anizone_id}`,
        body
      )
    }
    const saved = await httpService.post(
      `watchOrReadList/${userId}/${listType}`,
      body
    )
    return { ...body, ...saved } // ← ← ← פה טריק חשוב
  } catch (err) {
    console.error(`❌ [watchOrReadList.save] ${err?.message || err}`)
    throw err
  }
}


async function remove(userId, listType, anizoneId) {
  try {
    return await httpService.delete(
      `watchOrReadList/${userId}/${listType}/${anizoneId}`
    )
  } catch (err) {
    console.error(`❌ [watchOrReadList.remove] ${err?.message || err}`)
    throw err
  }
}

async function updateProgress(userId, listType, anizoneId, progress) {
  try {
    return await httpService.put(
      `watchOrReadList/${userId}/${listType}/${anizoneId}/progress`,
      { progress }
    )
  } catch (err) {
    console.error(`❌ [watchOrReadList.updateProgress] ${err?.message || err}`)
    throw err
  }
}

async function updateStatus(userId, listType, anizoneId, status) {
  try {
    return await httpService.put(
      `watchOrReadList/${userId}/${listType}/${anizoneId}/status`,
      { status }
    )
  } catch (err) {
    console.error(`❌ [watchOrReadList.updateStatus] ${err?.message || err}`)
    throw err
  }
}

async function updateTotalRewatch(userId, listType, anizoneId, total) {
  try {
    return await httpService.put(
      `watchOrReadList/${userId}/${listType}/${anizoneId}/total-rewatch`,
      { totalRewatchs: total }
    )
  } catch (err) {
    console.error(
      `❌ [watchOrReadList.updateTotalRewatch] ${err?.message || err}`
    )
    throw err
  }
}
